import { Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ISmarcador, Marcador } from "../../types/marcador/Marcador";
import { MarcadorDTO } from "../../types/marcador/MarcadorDTO";
import errorFormat from "../../utils/errorFormat";
import { useAddMarcadorMutation, useGetMarcadorQuery } from "./marcadorApiSlice";




export const MarcadorCreate = () => {


    const [cor, setCor] = useState<string>('#0000'); // valor inicial de cor

    const [marcador, SetMarcador] = useState<Marcador>(ISmarcador);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createMarcador, status] = useAddMarcadorMutation();
    const navigate = useNavigate();


    //verificar se for edicao ele pega o id e faz a consulta 
    const id = useParams().id || "";
    const { data, isFetching, error } = useGetMarcadorQuery(id);
    useEffect(() => {
        if (data) {
            SetMarcador(data);
            setCor(data.cor || '#0000')
        }

    }, [data, error, isFetching])





    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;


        SetMarcador((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };


    const handleChangeCor = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedColor = event.target.value;
        setCor(selectedColor);
        SetMarcador((prev) => ({
            ...prev,
            cor: selectedColor
        }));
    };


    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const parms: MarcadorDTO = {
            id: marcador.id,
            descricao: marcador.descricao,
            cor: cor,
        }
       
        await createMarcador(parms);
    }

    useEffect(() => {

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(-1);
            // setGrupo(ISgrupo);          

        }
    }, [status]);








    return (



        <>


            <Paper>
                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Marcadore(s)
                </Typography>

                <Box mt={2} p={2}>
                    <form onSubmit={handleSubmit} method='POST'>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        required
                                        label="Descricão:"
                                        name="descricao"
                                        onChange={handleChange}
                                        size="small"
                                        inputProps={{ maxLength: 255 }}
                                        value={marcador.descricao}
                                        multiline  // Adiciona o suporte a múltiplas linhas
                                        rows={4} />


                                    <FormHelperText>
                                        {marcador.descricao?.length}/255 caracteres
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <div>
                                        <h3>Escolha uma cor</h3>
                                        <input
                                            type="color"
                                            value={cor}
                                            onChange={handleChangeCor}
                                        />
                                        <p>Cor selecionada: <span style={{ color: cor }}>{cor}</span></p>
                                    </div>
                                </FormControl>
                            </Grid>


                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Gravar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </form>



                </Box>




            </Paper>










        </>







    );










};

/*
 <GrupoTurmaForm
                    grupoTurma={grupoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/